import { createAction, props } from '@ngrx/store';

export * from './prospect-buying-wish-generated.actions';

export const deleteManyProspectBuyingWishByProspectSuccess = createAction(
  '[ProspectBuyingWish] Delete Many Prospects Buying Wish By Prospect',
  props<{ idProspect: number }>()
);
